import { createSlice } from '@reduxjs/toolkit';
// import { createSelector } from 'reselect';
// import { convertZoomToPropertyGroupLevel, isBreakoutBasedOnZoom } from "api/rex/spatial";

export const initialState = {
  propertyDetailsData: null,
}

// create slice will call createAction and createReducer for us internally
const slice = createSlice({
  name: 'exploreProspectsSlice',
  initialState,
  reducers: {
    setProspectsPropertyDetailsData: (state, action) => {
      state.propertyDetailsData = action.payload;
    },
  }
});

export default slice.reducer;

export const exploreProspectsActions = slice.actions;

// Memoized selectors
// export const exploreProspectsSelectors = {
//   exploreDataSelector: createSelector(
//     state => state.exploreData,
//     exploreData => exploreData
//   )
// }
